class Session {
  static session = JSON.parse(localStorage.getItem("sessionInfo"))
  static getSession() {
    return this.session
  }
  static setSession(value) {
    localStorage.setItem("sessionInfo", JSON.stringify(value))
  }
  static removeSession() {
    localStorage.removeItem("sessionInfo")
  }
}

export const session = Session.session;
export default Session;

// module.exports = {
//   session: JSON.parse(localStorage.getItem("sessionInfo")),
//   getSession: function () {
//     return this.session
//   },
//   setSession: function (value) {
//     localStorage.setItem("sessionInfo", JSON.stringify(value))
//   },
//   removeSession: function () {
//     localStorage.removeItem("sessionInfo")
//   }
// }


// WEBPACK FOOTER //
// ./src/services/session.jsx